import Component from './Component';
import React from 'react';
import {LoadingButton} from 'reactis-loader';
import ActionButton from './ActionButton';

export default class SaveButton extends ActionButton {

	static defaultProps = {
		title: 'Uložit'
	};


	render() {
		return (
				<LoadingButton
					loading={this.props.loading}
					disabled={this.props.disabled}
					bsStyle={this.props.bsStyle}
					title={this.props.title}
					onClick={()=>this.handleClick()}
				/>
			)
	}
}


// WEBPACK FOOTER //
// ./src/components/SaveButton.js